import React, { useState, useEffect, useRef } from "react";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomBarChart from "../CustomComponents/CustomBarChart/CustomBarChart";
import clsx from "clsx";
import CustomFormControl from "../CustomComponents/CustomFormControl/CustomFormControl";
import {
    CustomRadio,
    CustomRadioGroup,
} from "../CustomComponents/CustomRadio/CustomRadio"
import { useStyles } from "../../assets/jss/Events";
import {
    getEventType,
    getUserData,
    getSession,
    getUserRBAC,
    isShowEventDetails,
    getSpeedIndex,
    getSpeedZoneIndex,
    setSpeedIndex,
    setSpeedZoneIndex,
    setIsCameFromEventDetailsPage,
    getIsCameFromEventDetailsPage
} from "../../services/LocalStorageService";
import trackEvents from "../../assets/appInsightsEvents";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { EventCode, RBAC_CODE, TableComponentCodes } from "../../config/app-globals.enum";
import {
    getMaxSpeed,
    getSpeedEventsSummary,
} from "../../services/EventsSummary";
import { useTranslation } from "react-i18next";
import PraisoTableWrapper from "../CustomComponents/PraisoTable/PraisoTableWrapper";
import { useParams } from "react-router-dom";
// import ShowMoreOrLess from "../CustomComponents/PraisoTable/ShowMoreOrLess";
// import DashboardPenaltyCard from "../DashboardPenaltyCard/DashboardPenaltyCard";

export default function SpeedingTab(props) {
    const params = useParams();
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [] = React.useState(
        getUserRBAC(RBAC_CODE.USER_DETAIL_VIEW, props)
    );
    const [userSession] = useState(getSession);
    const [pageLength, setPageLength] = useState(null);
    const [, setPageLengthArray] = useState(null);
    const [] = React.useState(getUserData);
    const [eventTypes] = React.useState(getEventType);
    const [isVisibleEventDtls] = React.useState(isShowEventDetails(EventCode.SPEEDING));
    const [speedingEvent, setSpeedingEvent] = React.useState(null);
    const [speedingZone, setSpeedingZone] = React.useState(null);
    const [speedingEventCounts, setSpeedingEventCounts] = React.useState(null);
    const [speedingEventDetails, setSpeedingEventDetails] = React.useState<any>([]);
    const [, setUserList] = React.useState(null);
    const [defaultFilterBy, setDefaultFilterBy] = React.useState({ speed: null });
    const [speedingZoneEventsLabel, setSpeedingZoneEventsLabel] =
        React.useState<any>(null);
    const [speedingZoneEventsCount, setSpeedingZoneEventsCount] =
        React.useState(null);
    const [selectedSpeedingZoneIndex, setSelectedSpeedingZoneIndex] =
        React.useState(0);
    const [page, setPage] = useState(0);
    const [, setRowsPerPage] = useState(null);
    const [showLimitedDriver, setShowLimitedDriver] = useState(null);
    //Filter API reponse for speed
    const [filteredTableData, setFilteredTableData] = useState(null);

    const [graphData, setGraphData] = useState({
        data: {
            labels: [],
            datasets: [],
        },
        speedingLimitData: {},
        limitKey: 0,
        limitIndex: 0,
        selectedBar: 0,
    });
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [isApi, setIsApi] = useState(false);
    const [isApi1, setIsApi1] = useState(false);
    // const [currentBar, setCurrentBar] = useState(0);
    const [speedingData, setSpeedingData] = useState<any>({
        loading: true,
        data: [],
        currentData: [],
    });

    //====
    useEffect(() => {
        if (eventTypes && eventTypes.length > 0) {
            const speedingEventObj = eventTypes.find(
                (event) => event.code === "SPEEDING"
            );
            setSpeedingEvent(speedingEventObj);
        }
    }, [eventTypes]);
    //====
    useEffect(() => {
        if (speedingZoneEventsLabel && speedingZoneEventsLabel.length) {
            const currentSelectedSpeed =
                speedingZoneEventsLabel[graphData.selectedBar];
            // const currentList = speedingEventDetails.filter(
            //   (event) => parseInt(event.speed) === parseInt(currentSelectedSpeed)
            // );
            // setUserList(currentList);
            // setDefaultFilterBy({ ...defaultFilterBy, speed: currentSelectedSpeed })
            setDefaultFilterBy({ speed: currentSelectedSpeed })
        }
    }, [graphData.selectedBar, speedingZoneEventsLabel]);
    //====

    async function loadMaxSpeedData() {
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        setIsApi(true);
        const data = await getMaxSpeed({ eventTypeId: speedingEvent.id }, params);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setIsApi(false);
            if (data.content.length) {
                const sortedSpeedZone = data.content.sort(
                    (item1, item2) => item1.speedZone - item2.speedZone
                );
                let index = sortedSpeedZone.findIndex((speed) => { return speed.maxSpeed > 0 });
                index = index === -1 ? 0 : index;
                if (getSpeedZoneIndex() !== undefined && getSpeedZoneIndex() !== null) {
                    setSelectedSpeedingZoneIndex(getSpeedZoneIndex());
                } else {
                    setSelectedSpeedingZoneIndex(index);
                }
                setSpeedingZone(sortedSpeedZone);
            }
        } else {
            setIsApi(false);
            setIsApiFailed(true);
            changeApiStatusCodeFunc(data.status);
            // errorSetting.changeApiStatusCode(data.status);
        }
    }

    useEffect(() => {
        if (speedingEvent) {
            loadMaxSpeedData();
        }
        return () => {
            setIsApi(false);
        }
    }, [speedingEvent]);
    //====

    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        // if ((getSpeedZoneIndex() === undefined || getSpeedZoneIndex() === null || getSpeedZoneIndex() === -1) && (getSpeedIndex() === undefined || getSpeedIndex() === null || getSpeedIndex() === -1)) {
        //     setIsCameFromEventDetailsPage(1);
        // }
        if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null && getIsCameFromEventDetailsPage() === 0) {
            setSpeedIndex(-1);
            setSpeedZoneIndex(-1);
        }
        return () => {
            mounted.current = false;
            if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null && getIsCameFromEventDetailsPage() === 1) {
                setIsCameFromEventDetailsPage(0);
            }

        };
    }, []);



    const handleGraphChange = (event) => {
        if (Math.trunc(event.target.value) !== selectedSpeedingZoneIndex) {
            setPage(0);
            setSpeedIndex(0);
            setUserList(null);
            setSpeedZoneIndex(Math.trunc(event.target.value));
            if (getSpeedZoneIndex() !== undefined && getSpeedZoneIndex() !== null) {
                setSelectedSpeedingZoneIndex(getSpeedZoneIndex());
            } else {
                setSelectedSpeedingZoneIndex(Math.trunc(event.target.value));
            }

        } else {

        }
    };

    //====
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };
    //====
    useEffect(() => {
        if (speedingEventCounts && speedingEventCounts.length > 0) {
            const eventCounts = [];
            for (const eventCount of speedingEventCounts) {
                eventCounts.push(eventCount.speed);
            }
            const eventCountsSorted = eventCounts.sort(
                (item1, item2) => item1 - item2
            );
            setSpeedingZoneEventsLabel([...new Set(eventCountsSorted)]);
        }
    }, [speedingEventCounts]);
    //====
    useEffect(() => {
        if (speedingZoneEventsLabel && speedingZoneEventsLabel.length > 0) {
            const speedCount = [];
            for (const speed of speedingZoneEventsLabel) {
                const eventsForSpeed = speedingEventCounts.filter(
                    (item) => item.speed === speed
                );
                let eventCountForSpecificSpeed = 0;
                for (const eventItem of eventsForSpeed) {
                    eventCountForSpecificSpeed += eventItem.eventCount;
                }
                speedCount.push(eventCountForSpecificSpeed);
            }
            setSpeedingZoneEventsCount(speedCount);
        }
    }, [speedingZoneEventsLabel]);
    //====

    async function loadData() {
        let selectedBarIndex = 0;
        if (getSpeedIndex() !== undefined && getSpeedIndex() !== null && getSpeedIndex() !== -1) {
            selectedBarIndex = getSpeedIndex();
        }
        setIsApi1(true);
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        const data = await getSpeedEventsSummary({
            eventTypeId: speedingZone[selectedSpeedingZoneIndex].eventTypeId,
        }, params);
        if (
            data &&
            data.status &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setSpeedingEventCounts(data.content.eventCounts);
            setSpeedingEventDetails(data.content.eventDetails);
            setGraphData({
                ...graphData,
                selectedBar: selectedBarIndex,
            });
            setIsApi1(false);
        } else {
            setIsApi1(false);
            setIsApiFailed(true);
            const staticGraph = {
                PenaltyPoints: 507,
                SpeedingLimitEventsMap: {
                    20: {
                        HighestSpeed: 29,
                        SpeedCountMap: { 23: 3, 24: 2, 26: 6, 27: 4, 28: 1, 29: 1 },
                    },
                    30: {
                        HighestSpeed: 52,
                        SpeedCountMap: {
                            33: 3,
                            34: 6,
                            35: 5,
                            36: 25,
                            37: 20,
                            38: 11,
                            39: 13,
                            40: 3,
                            41: 5,
                            42: 4,
                            45: 1,
                            52: 1,
                        },
                    },
                    40: {
                        HighestSpeed: 63,
                        SpeedCountMap: {
                            44: 2,
                            45: 3,
                            46: 1,
                            47: 3,
                            48: 1,
                            49: 5,
                            50: 7,
                            51: 3,
                            52: 5,
                            53: 2,
                            54: 2,
                            55: 3,
                            56: 3,
                            63: 1,
                        },
                    },
                    50: {
                        HighestSpeed: 63,
                        SpeedCountMap: {
                            54: 6,
                            55: 26,
                            56: 10,
                            57: 3,
                            59: 1,
                            60: 2,
                            62: 1,
                            63: 1,
                        },
                    },
                    60: { HighestSpeed: 65, SpeedCountMap: { 65: 2 } },
                    70: { HighestSpeed: 80, SpeedCountMap: { 77: 1, 80: 1 } },
                },
                ApiRootPath: "/api/",
                StartDate: "2020-10-16T06:42:30.295148+01:00",
                EndDate: "2020-11-06T06:42:30.295148+00:00",
                MaxEventsPerPage: 100,
            };
            setSpeedingData({
                ...speedingData,
                data: staticGraph,
                loading: false,
            });
            changeApiStatusCodeFunc(data.status);
        }
    }

    useEffect(() => {
        if (speedingZone && speedingZone.length) {
            loadData();
        }
    }, [selectedSpeedingZoneIndex, speedingZone]);

    useEffect(() => {
        if (speedingZoneEventsCount) {
            const borderWidth = speedingZoneEventsLabel.map((dt, index) => {
                let width = graphData.selectedBar === index ? 1 : 0;
                return width;
            });
            const borderColor = speedingZoneEventsLabel.map((dt, index) => {
                let color =
                    graphData.selectedBar === index
                        ? isApiFailed
                            ? "rgb(241, 242, 246)"
                            : "rgba(249, 208, 55, 1)"
                        : isApiFailed
                            ? "rgb(241, 242, 246)"
                            : "rgba(255, 187, 0, 0.3)";
                if (
                    parseInt(speedingZoneEventsLabel[index]) >
                    speedingZone[selectedSpeedingZoneIndex].speedZone * 1.1
                ) {
                    color =
                        graphData.selectedBar === index
                            ? isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(249, 208, 55, 1)"
                            : isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(204, 0, 0, 0.3)";
                }
                if (
                    parseInt(speedingZoneEventsLabel[index]) >
                    speedingZone[selectedSpeedingZoneIndex].speedZone * 1.2
                ) {
                    color =
                        graphData.selectedBar === index
                            ? isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(249, 208, 55, 1)"
                            : isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(128, 0, 128, 0.3)";
                }
                return color;
            });
            const bgColor = speedingZoneEventsLabel.map((dt, index) => {
                let color =
                    graphData.selectedBar === index
                        ? isApiFailed
                            ? "rgb(241, 242, 246)"
                            : "rgba(255, 187, 1)"
                        : "rgba(255, 187, 0, 0.3)";
                if (
                    parseInt(speedingZoneEventsLabel[index]) >
                    speedingZone[selectedSpeedingZoneIndex].speedZone * 1.1
                ) {
                    color =
                        graphData.selectedBar === index
                            ? isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(204, 0, 0, 1)"
                            : isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(204, 0, 0, 0.3)";
                }
                if (
                    parseInt(speedingZoneEventsLabel[index]) >
                    speedingZone[selectedSpeedingZoneIndex].speedZone * 1.2
                ) {
                    color =
                        graphData.selectedBar === index
                            ? isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(128, 0, 128, 1)"
                            : isApiFailed
                                ? "rgb(241, 242, 246)"
                                : "rgba(128, 0, 128, 0.3)";
                }
                return color;
            });
            setGraphData({
                ...graphData,
                data: {
                    labels: speedingZoneEventsLabel,
                    datasets: [
                        {
                            label: t("SPEEDING_EVENTS"),
                            barPercentage: 0.5,
                            barThickness: 20,
                            borderWidth: borderWidth,
                            borderColor: borderColor,
                            maxBarThickness: 20,
                            minBarLength: 2,
                            data: speedingZoneEventsCount,
                            backgroundColor: bgColor,
                        },
                    ],
                },
            });
        }
    }, [speedingZoneEventsCount, graphData.selectedBar]);

    useEffect(() => {
        if (getSpeedIndex() !== undefined && getSpeedIndex() !== null && getSpeedIndex() !== -1) {
            setPage(getSpeedIndex());
        } else {
            setPage(graphData.selectedBar);
        }

    }, [graphData.selectedBar]);

    useEffect(() => {
        if (userSession) {
            setPageLength(userSession.pageLength);
        }
    }, [userSession]);

    useEffect(() => {
        if (pageLength) {
            /** @todo: pagination array need to be dynamic */
            // const pageArray = [
            //   pageLength,
            //   pageLength * 2,
            //   pageLength * 5,
            //   pageLength * 10,
            //   pageLength * 20,
            // ];
            const pageArray = [10, 100, 500];
            // setRowsPerPage(pageLength);
            setRowsPerPage(10);
            setPageLengthArray(pageArray);
        }
    }, [pageLength]);



    async function getFilteredTableData(isFreshCall?: boolean) {
        if (getSpeedIndex() !== undefined && getSpeedIndex() !== null && getSpeedIndex() !== -1) {
            setPage(getSpeedIndex());
        }
        if (isFreshCall === undefined || !isFreshCall) {
            loadData();
        }
        let filteredData = [];
        for (let i = 0; i < speedingEventDetails.length; i++) {
            if (speedingEventDetails[i].speed === defaultFilterBy.speed) {
                filteredData.push(speedingEventDetails[i]);
            }
        }
        setFilteredTableData(filteredData);
    }

    useEffect(() => {
        // let filteredData = [];
        // for (let i = 0; i < speedingEventDetails.length; i++) {
        //     if (speedingEventDetails[i].speed === defaultFilterBy.speed) {
        //         filteredData.push(speedingEventDetails[i]);
        //     }
        // }
        // setFilteredTableData(filteredData);
        getFilteredTableData(true);
    }, [defaultFilterBy]);

    return (
        <>
            <CustomGrid container spacing={4} justifyContent="space-between">
                <CustomGrid item xs={12}>
                    <CustomPaper square elevation={0}>
                        {isApi ? (
                            <CustomCard
                                elevation={0}
                                className={clsx(
                                    classes.cardContentWrapper,
                                    classes.cardContentWrapperCenter
                                )}
                            >
                                {isApi && (
                                    <CustomPaper
                                        className={classes.loadingContainer}
                                        elevation={0}
                                    >
                                        <CustomCircularProgress />
                                    </CustomPaper>
                                )}
                            </CustomCard>
                        ) : null}
                        {!isApi ? (
                            <CustomCard
                                elevation={0}
                                className={clsx(
                                    classes.cardContentWrapper,
                                    isApiFailed ? classes.graphDisabled : null
                                )}
                            >
                                {!isApi && (
                                    <CustomCardContent
                                        className={classes.cardContent}
                                        style={{ padding: "1.5em 3em" }}
                                    >
                                        <CustomGrid
                                            container
                                            justifyContent="space-between"
                                            alignItems="center"
                                            spacing={0}
                                        >
                                            <CustomGrid item xs={12}>
                                                <div className={classes.performanceCheckboxContainer}>
                                                    <CustomFormControl fullWidth component="fieldset">
                                                        <CustomRadioGroup
                                                            row
                                                            aria-label="dateRange"
                                                            name="dateRange"
                                                            value={selectedSpeedingZoneIndex}
                                                            onChange={($event) => handleGraphChange($event)}
                                                            className={clsx(
                                                                classes.performanceRadioGroup,
                                                                isApiFailed
                                                                    ? classes.performanceRadioGroupDisabled
                                                                    : null
                                                            )}
                                                        >
                                                            {speedingZone &&
                                                                speedingZone.length &&
                                                                speedingZone.map((item, index) => {
                                                                    return (
                                                                        <div
                                                                            key={`${index}-speedingRadio`}
                                                                            className={classes.speedRangeCard}
                                                                        >
                                                                            <CustomRadio
                                                                                color="primary"
                                                                                value={`${index}`}
                                                                                disabled={isApi1 ? isApi1 : item.maxSpeed <= 0}
                                                                            />
                                                                            <div
                                                                                className={clsx(
                                                                                    classes.speedRangeCardInner,
                                                                                    selectedSpeedingZoneIndex === index
                                                                                        ? clsx(
                                                                                            classes.speedRangeCardSelected,
                                                                                            isApiFailed ||
                                                                                                item.maxSpeed <= 0
                                                                                                ? classes.speedRangeCardSelectedDisabled
                                                                                                : null
                                                                                        )
                                                                                        : null
                                                                                )}
                                                                            >
                                                                                <span
                                                                                    className={clsx(
                                                                                        classes.speedLimit,
                                                                                        isApiFailed || item.maxSpeed <= 0
                                                                                            ? classes.speedLimitDisabled
                                                                                            : null
                                                                                    )}
                                                                                >
                                                                                    <span
                                                                                        className={classes.speedLimitValue}
                                                                                    >
                                                                                        {item.speedZone}
                                                                                    </span>
                                                                                    <span
                                                                                        className={clsx(
                                                                                            classes.speedLimitUnit,
                                                                                            isApiFailed || item.maxSpeed <= 0
                                                                                                ? classes.speedLimitUnitDisabled
                                                                                                : null
                                                                                        )}
                                                                                    >
                                                                                        MPH
                                                                                    </span>
                                                                                </span>
                                                                                <span
                                                                                    className={clsx(
                                                                                        classes.maxSpeed,
                                                                                        isApiFailed || item.maxSpeed <= 0
                                                                                            ? classes.maxSpeedDisabled
                                                                                            : null
                                                                                    )}
                                                                                >
                                                                                    <span
                                                                                        className={clsx(
                                                                                            classes.maxSpeedValue,
                                                                                            isApiFailed || item.maxSpeed <= 0
                                                                                                ? classes.maxSpeedValueDisabled
                                                                                                : null
                                                                                        )}
                                                                                    >
                                                                                        {item.maxSpeed > 0 &&
                                                                                            Math.trunc(item.maxSpeed)}
                                                                                    </span>{" "}
                                                                                    {item.maxSpeed > 0
                                                                                        ? i18n.t("MAX_SPEED_FOUND", {
                                                                                            speedUnit: "MPH",
                                                                                        })
                                                                                        : t("NO_SPEED_EVENT_FOUND")}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </CustomRadioGroup>
                                                    </CustomFormControl>
                                                </div>
                                            </CustomGrid>
                                            <CustomGrid container>
                                                <CustomGrid item xs={12}>
                                                    {isApi1 ? (
                                                        <CustomCard
                                                            elevation={0}
                                                            className={clsx(
                                                                classes.cardContentWrapper,
                                                                classes.cardContentWrapperCenter
                                                            )}
                                                        >
                                                            {isApi1 && (
                                                                <CustomPaper
                                                                    className={classes.loadingContainer}
                                                                    elevation={0}
                                                                >
                                                                    <CustomCircularProgress />
                                                                </CustomPaper>
                                                            )}
                                                        </CustomCard>
                                                    ) :
                                                        <CustomBarChart
                                                            className={classes.reportGraph}
                                                            data={graphData.data}
                                                            options={{
                                                                legend: { display: false },
                                                                scales: {
                                                                    xAxes: [
                                                                        {
                                                                            ticks: { beginAtZero: true },
                                                                            gridLines: { display: false },
                                                                        },
                                                                    ],
                                                                    yAxes: [
                                                                        {
                                                                            ticks: { beginAtZero: true },
                                                                            gridLines: { display: false },
                                                                        },
                                                                    ],
                                                                },
                                                                onClick: (e, item) => {
                                                                    if (item.length !== 0) {
                                                                        trackEvents("Event", {
                                                                            name: "Speeding Bar",
                                                                            value:
                                                                                graphData.data.labels[item[0]["_index"]],
                                                                        }, params);
                                                                    }
                                                                    item &&
                                                                        item[0] &&
                                                                        setGraphData({
                                                                            ...graphData,
                                                                            selectedBar: item[0]["_index"],
                                                                        });
                                                                    setSpeedIndex(item[0]["_index"]);
                                                                },
                                                            }}
                                                            height={70}
                                                        />}
                                                </CustomGrid>
                                            </CustomGrid>
                                        </CustomGrid>
                                    </CustomCardContent>
                                )}
                            </CustomCard>
                        ) : null}
                    </CustomPaper>
                </CustomGrid>
            </CustomGrid>
            <CustomGrid container spacing={4} justifyContent="space-between">
                <CustomGrid item xs={12} className={classes.cardContentWrapper}>
                    {!isApi1 && !isApiFailed && isVisibleEventDtls &&
                        speedingZone && speedingZone.length &&
                        selectedSpeedingZoneIndex >= 0
                        ? (
                            <PraisoTableWrapper
                                getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.SPEEDING_EVENT_USER_LIST}`}
                                tableSettingView={TableComponentCodes.SPEEDING_EVENT_USER_LIST}
                                preFetchedTableData={filteredTableData}
                                callBackFun={getFilteredTableData}
                                {...props}
                            />

                        ) : null}
                </CustomGrid>
            </CustomGrid>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
